<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="part">The eight novels in this series, carrying the story of an American family forward from its beginning in Revolutionary times to the two-hundredth anniversary of the Republic, could only be dedicated, book by book, to the eight Americans I love best of all. And so, Rachel, this is for you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-part.vue?7d950aa2